<template>
    <div>
        <treeselect
                valueFormat="object"
                v-model="currentSelected"
                :multiple="true"
                :async="false"
                :options="currentOptions"
                :clear-on-select="true"
                ref="select"

                :placeholder="currentLang.placeholder"
                :retryTitle="currentLang.retryTitle"
                :retryText="currentLang.retryText"
                :noOptionsText="currentLang.noOptionsText"
                :noResultsText="currentLang.noResultsText"
                :noChildrenText="currentLang.noChildrenText"
                :searchPromptText="currentLang.searchPromptText"
                :clearValueText="currentLang.clearValueText"
                :clearAllText="currentLang.clearAllText"
        ></treeselect>

        <input type="hidden" name="site_product_features[]" v-model="encodedData" />
    </div>
</template>

<script>
    import Treeselect from '@riophae/vue-treeselect'

    import '@riophae/vue-treeselect/dist/vue-treeselect.css'

    export default {
        components: {
            Treeselect
        },
        props: {
            site: {
                required: true,
                type: Object,
            },
            lang: {
                required: false,
                type: Object,
            },
            selected: {
                required: false,
                type: Array
            },
            options: {
                required: false,
                type: Array
            }
        },
        data: function () {
            return {
                currentLang: {
                    'placeholder': 'Select...',
                    'retryTitle': 'Click to retry',
                    'retryText': 'Retry?',
                    'noOptionsText': 'No options available.',
                    'noResultsText': 'No results found...',
                    'noChildrenText': 'No sub-options.',
                    'searchPromptText': 'Type to search...',
                    'clearValueText': 'Clear value',
                    'clearAllText': 'Clear all'
                },
                currentSelected: null,
                currentOptions: []
            }
        },
        methods: {
            changeLang() {
                _.forEach(this.lang, (value, key) => {
                    this.currentLang[key] = value;
                });
            }
        },
        computed: {
            encodedData() {
                return JSON.stringify({
                    site: this.site.id,
                    data: this.currentSelected
                });
            }
        },
        mounted() {

            this.currentOptions = this.site.product_features.map(i => ({
                id: `${i.id}`,
                label: i.name ? `${i.name}` : `${i.id}`
            }));

            this.currentSelected = this.selected.map(i => ({
                id: `${i.id}`,
                label: i.name ? `${i.name}` : `${i.id}`
            }));


            this.changeLang();
        },
        created() {
        }

    }
</script>
